<template>
  <div>
    <iframe
      id="iframe-overview"
      ref="myElement"
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_URL_FRONTEND_NEW_MITRA}/check-top-up-idle?iframe=true`"
      allow="clipboard-read; clipboard-write"
    />
    <ModalCheckTopup
      id="modal-check-topup"
      :partner-idx="partnerIdx"
      @success-topup="reloadIframe"
    />
    <ModalCancelTopup
      id="modal-cancel-topup"
      :partner-idx="partnerIdx"
      @cancel-topup="reloadIframe"
    />
  </div>
</template>

<script>
import ModalCheckTopup from './ModalCheckTopup.vue'
import ModalCancelTopup from './ModalCancelTopup.vue'

export default {
  components: {
    ModalCheckTopup,
    ModalCancelTopup,
  },
  data() {
    return {
      VUE_APP_URL_FRONTEND_NEW_MITRA: process.env.VUE_APP_URL_FRONTEND_NEW_MITRA,
      height: 0,
      partnerIdx: 0,
    }
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === this.VUE_APP_URL_FRONTEND_NEW_MITRA) {
        const {
          type, data, partnerId, status,
        } = event.data

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }

        if (status === 'check') {
          this.partnerIdx = partnerId
          this.openModalCheck()
        }

        if (status === 'refund') {
          this.partnerIdx = partnerId
          this.openModalCancel()
        }
      }
    })
  },
  methods: {
    openModalCheck() {
      this.$root.$emit('bv::show::modal', 'modal-check-topup')
    },
    openModalCancel() {
      this.$root.$emit('bv::show::modal', 'modal-cancel-topup')
    },
    reloadIframe() {
      const baseUrl = `${this.VUE_APP_URL_FRONTEND_NEW_MITRA}/check-top-up-idle?iframe=true`
      this.$refs.myElement.src = baseUrl
    },
  },
}
</script>

<style></style>
